import { getIcon } from '../utils/helper';

export const CRMEventType = {
  TELEPHONE: 'TELEPHONE',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PERSONAL: 'PERSONAL',
  ONLINE: 'ONLINE',
};

export const CRMCalendarStatus = {
  FINISHED: 'FINISHED',
  UPCOMING: 'UPCOMING',
  EXPIRED: 'EXPIRED',
  FINISHED_UPCOMING: 'FINISHED_UPCOMING',
};

export const CRMEventTypeList = [
  { label: 'Telefon', value: CRMEventType.TELEPHONE, icon: getIcon('Phone') },
  { label: 'Email', value: CRMEventType.EMAIL, icon: getIcon('Email') },
  { label: 'SMS', value: CRMEventType.SMS, icon: getIcon('Sms') },
  { label: 'Személyes', value: CRMEventType.PERSONAL, icon: getIcon('People') },
  { label: 'Online', value: CRMEventType.ONLINE, icon: getIcon('VideoCameraFront') },
];

export const CRMCalendarStatusColor = [
  { color: 'blue', value: CRMCalendarStatus.FINISHED },
  { color: 'green', value: CRMCalendarStatus.UPCOMING },
  { color: 'red', value: CRMCalendarStatus.EXPIRED },
  { color: 'blue', value: CRMCalendarStatus.FINISHED_UPCOMING },
];
